var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSherlock(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 681 860",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M546.72 860.12H446.6c-17.83 0-32.31-14.48-32.31-32.31v-21.02c0-6.23 5.06-11.29 11.29-11.29h121.14c17.83 0 32.31 14.48 32.31 32.31 0 17.83-14.48 32.31-32.31 32.31z",
    fill: "#FD934F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.29 795.79l-1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.06 677.22v53.29c0 14.23-11.53 25.76-25.76 25.76h-6.02c-14.23 0-25.76 11.53-25.76 25.76 0 14.23 11.53 25.76 25.76 25.76h153.07",
    fill: "#2A848E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M674.95 617.24c12.74 16.6 4.97 40.74-15.02 46.95-52.2 16.22-111.23-.63-146.44-46.53-43.94-57.27-34.6-138.65 20.17-184.59l141.29 184.16v.01z",
    fill: "#006C78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M564.74 366.14v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H227.21c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V366.14c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.14 860.12H212.02c-17.83 0-32.31-14.48-32.31-32.31v-21.02c0-6.23 5.06-11.29 11.29-11.29h121.14c17.83 0 32.31 14.48 32.31 32.31 0 17.83-14.48 32.31-32.31 32.31z",
    fill: "#FD934F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.72 795.79l-1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.45 270.59c5.97-12.79 16.79-23.33 31.02-28.51 14.23-5.18 29.29-4.07 42.08 1.9l13.04 19.4-75.07 27.41-11.07-20.2z",
    fill: "#2A848E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M504.74 692.19V540.42c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M346.14 644.47c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM437.81 644.47c13.24 9.45 31.62-.02 31.62-16.28v-55.34c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65v-.01z",
    fill: "#FA505E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M340.35 600.51h103.26",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M400.14 582.35h-16.32c-5.523 0-10 4.477-10 10v16.32c0 5.522 4.477 10 10 10h16.32c5.523 0 10-4.478 10-10v-16.32c0-5.523-4.477-10-10-10z",
    fill: "#FA505E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M400.14 582.35c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32zm0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#F93444"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M446.39 408.9h-68.88c-14.172 0-25.66 11.488-25.66 25.66 0 14.171 11.488 25.66 25.66 25.66h68.88c14.172 0 25.66-11.489 25.66-25.66 0-14.172-11.488-25.66-25.66-25.66z",
    fill: "#FED425"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M351.85 434.55v12.17c0 22.09 17.91 40 40 40h27.86c16.57 0 30-13.43 30-30v-12.17l-97.86-10z",
    fill: "#FED425"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M438.24 455.14h-37.51c-11.17 0-21.57-5.73-27.53-15.18",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M508.71 358.43l-80.96 23.2 80.96 23.21",
    stroke: "#024447",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M513.19 298.53l-95.34 32.71v-31.82l29.39 15.46",
    fill: "#006C78"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M513.19 298.53l-95.34 32.71v-31.82l29.39 15.46",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M300.76 528.91v163.41c0 11.05-8.95 20-20 20H121.92c-11.05 0-20-8.95-20-20v-223.8c0-6.68 6.43-11.49 12.84-9.59l171.68 50.8a19.998 19.998 0 0114.33 19.18h-.01z",
    fill: "#D68C63"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M240.26 588.43H101.92v103.89c0 11.05 8.95 20 20 20h98.35c11.05 0 20-8.95 20-20V588.43h-.01z",
    fill: "#D26F45"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M569.44 676.43l84.88-84.88a9.991 9.991 0 00.93-13.06l-84.75-113.2c-3.22-4.3-9.27-5.29-13.69-2.23l-20.63 14.25a10.004 10.004 0 00-4.29 7.46L520.3 635.64c-.22 2.86.8 5.68 2.8 7.74l32.08 32.97c3.89 4 10.29 4.04 14.24.1l.02-.02z",
    fill: "#D68C63"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M482.83 524.5v167.82c0 11.05 8.95 20 20 20h45.65c11.05 0 20-8.95 20-20V474.14c0-8.05-9.03-12.8-15.66-8.24l-61.31 42.12c-5.43 3.73-8.68 9.9-8.68 16.48zM135.19 462.83l-35.77 1.9c-4.6 0-8.93 15.4-11.73 19.05l-69.84 91.03v29.5c8.36 16.96 25.82 28.64 46.01 28.64h95.5V496.27c-6.73-7.64-14.96-29.03-24.17-33.44z",
    fill: "#D68C63"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4 533.67l43.23-56.35c0-12.32 11.89-21.14 23.68-17.56l64.31 18.64M568.47 679.36V562.54",
    stroke: "#D26F45",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.9 61.67l-24.91 7.15.04.14c-.02-.06-1.93-6.04-7.2-11.09-6.6-6.33-15.9-8.6-27.62-6.73-7.07 1.12-13.71-3.7-14.83-10.77-1.12-7.07 3.7-13.71 10.77-14.83 26-4.13 42 5.78 50.84 14.82 9.37 9.58 12.59 20.13 12.92 21.31h-.01z",
    fill: "#D26F45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.87 77.42c-6.34 2.31-13.48-.66-16.26-6.91-.5-1.11-4.81-11.27-3.79-24.63.96-12.61 6.85-30.48 29.42-44.03 6.14-3.68 14.1-1.7 17.78 4.44 3.68 6.14 1.7 14.1-4.44 17.78-10.5 6.3-16.19 14.31-16.91 23.78-.52 6.79 1.61 12.07 1.63 12.12 2.91 6.54-.03 14.2-6.57 17.11-.28.13-.56.24-.85.34h-.01z",
    fill: "#D26F45"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M551.83 219.76C494.27 87.7 356.61 17.03 235.9 60.97 115.18 104.91 55.15 247.53 95.95 385.69l455.89-165.93h-.01z",
    fill: "#D68C63"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.93 62.48C113.87 108.07 55.6 249.06 95.94 385.69l135.99-49.49V62.48z",
    fill: "#C64F36"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M551.83 219.76C494.27 87.7 356.61 17.03 235.9 60.97",
    stroke: "#D26F45",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M403.45 304.6l-26.58-12.39c-19.62-9.15-18.38-37.45 1.96-44.86l156.9-57.11a97.156 97.156 0 0174.32 3.25l20.5 9.56c19.62 9.15 18.38 37.45-1.96 44.86l-163.2 59.4a81.039 81.039 0 01-61.94-2.7v-.01z",
    fill: "#D68C63"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M442.75 224.08l92.98-33.84a97.156 97.156 0 0174.32 3.25l20.5 9.56c19.62 9.15 18.38 37.45-1.96 44.86l-17.08 6.22",
    stroke: "#D26F45",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.1 398.5l19.24-41.26c6.1-13.08-6.66-27.01-20.22-22.07L109.13 349a89.08 89.08 0 00-50.28 46.07l-10.98 23.54c-9.15 19.62 9.99 40.51 30.33 33.1l19.62-7.14a89.08 89.08 0 0050.28-46.07z",
    fill: "#C64F36"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M351.71 244.04c-25.11-69-64.04-131.4-113.73-183.77-.7.23-1.4.45-2.09.71-71.03 25.85-122.25 148.34-67.63 298.4l199.06-72.45-15.61-42.88v-.01z",
    fill: "#D26F45"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M265.567 497.685l-29.011-11.427-16.492 41.868 29.01 11.428 16.493-41.869z",
    fill: "#86B1B2",
    stroke: "#86B1B2",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M256.251 542.368l-43.367-17.083a7.041 7.041 0 00-9.13 3.97l-45.717 116.061a7.04 7.04 0 003.97 9.13l43.366 17.083a7.041 7.041 0 009.131-3.97l45.717-116.061a7.04 7.04 0 00-3.97-9.13z",
    fill: "#FED425",
    stroke: "#FED425",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.22 506.91c71.377 0 129.24-57.863 129.24-129.24 0-71.378-57.863-129.24-129.24-129.24-71.377 0-129.24 57.862-129.24 129.24 0 71.377 57.863 129.24 129.24 129.24z",
    fill: "#AACACC",
    stroke: "#AACACC",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M180.62 301.7c37.07-53.91 107.63-77.19 171.1-52.18 14.57 5.74 27.68 13.6 39.12 23.08",
    stroke: "#6DA4A7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.22 478.38c55.621 0 100.71-45.09 100.71-100.71 0-55.621-45.089-100.71-100.71-100.71-55.621 0-100.71 45.089-100.71 100.71 0 55.62 45.089 100.71 100.71 100.71z",
    fill: "#91F1F2",
    stroke: "#91F1F2",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M348.47 342.25c11.15 2.81 21.48 6.46 30.91 10.82 8.02 3.7 16.65-4.26 13.46-12.5-.03-.07-.05-.13-.08-.2-10.26-25.71-31.03-47.17-59.3-57.41-50.56-18.32-107.17 6.85-127.48 56.64-.13.31-.25.62-.37.92-.03.08-.06.16-.1.24-3.17 8.3 5.52 16.14 13.59 12.43 37.06-17.07 84.84-22.17 129.36-10.95l.01.01z",
    fill: "#EBFAFA",
    stroke: "#EBFAFA",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218.66 554.59H75.97C38.431 554.59 8 585.021 8 622.56c0 37.538 30.431 67.97 67.97 67.97h142.69c37.539 0 67.97-30.432 67.97-67.97 0-37.539-30.431-67.97-67.97-67.97z",
    fill: "#2A848E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M218.66 690.52c37.38 0 67.97-30.59 67.97-67.97 0-37.38-30.59-67.97-67.97-67.97",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.78 554.59H75.97C38.59 554.59 8 585.18 8 622.56c0 37.38 30.59 67.97 67.97 67.97h92.81V554.59z",
    fill: "#D68C63"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.78 554.59H75.97C38.59 554.59 8 585.18 8 622.56c0 37.38 30.59 67.97 67.97 67.97h92.81V554.59z",
    stroke: "#D68C63",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M315.3 383.22c-4.27-2.46-4.27-8.62 0-11.09l31.08-17.94v-15.94c0-26-21.15-47.16-47.16-47.16-26.01 0-47.16 21.15-47.16 47.16v78.85c0 26 21.15 47.16 47.16 47.16 26.01 0 47.16-21.15 47.16-47.16v-15.94l-31.08-17.94z",
    fill: "#024447"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M178.08 554.59H90.97",
    stroke: "#D26F45",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M506.61 565.97c6.053 0 10.96-4.907 10.96-10.96 0-6.053-4.907-10.96-10.96-10.96-6.053 0-10.96 4.907-10.96 10.96 0 6.053 4.907 10.96 10.96 10.96zM148.97 688.18c6.053 0 10.96-4.907 10.96-10.96 0-6.053-4.907-10.96-10.96-10.96-6.053 0-10.96 4.907-10.96 10.96 0 6.053 4.907 10.96 10.96 10.96zM506.61 622.44c6.053 0 10.96-4.907 10.96-10.961 0-6.053-4.907-10.959-10.96-10.959-6.053 0-10.96 4.906-10.96 10.959 0 6.054 4.907 10.961 10.96 10.961zM506.61 678.91c6.053 0 10.96-4.907 10.96-10.96 0-6.054-4.907-10.96-10.96-10.96-6.053 0-10.96 4.906-10.96 10.96 0 6.053 4.907 10.96 10.96 10.96z",
    fill: "#D26F45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSherlock);
export default ForwardRef;